import { SearchNoResult } from "@ic-anywhere/ic-components";
import * as React from "react";
import { Loader } from "@access-selfcare/shared-libs";
import { isEmpty } from "lodash";
import DashboardFilters from "./Filters/DashboardFilters";
import DashboardHeader from "./Header/DashboardHeader";
import { useEventsDashboard } from "./Hooks/useEventsDashboard";
import EventsList from "./List/EventsList";

const Dashboard: React.FC = () => {
  const { isFetching, events } = useEventsDashboard();

  return (
    <div className="container-xxl">
      <DashboardHeader />
      <DashboardFilters />
      <Loader containerClass={"d-flex justify-content-center"} isVisible={isFetching} />
      {isEmpty(events) && !isFetching && (
        <SearchNoResult title={"No event available"} icon="info_outline" containerClassName="mt-3" />
      )}
      <div className="row g-4 mt-3">
        <EventsList events={events} />
      </div>
    </div>
  );
};

export default Dashboard;
